import React from 'react';
import { CONSTANTS_REQ } from '../../utils/Constants';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { GetEnum } from '../../utils/Enums';
import ApplicationEdit from './edit';
import { ENUMS, getColumnSearch, getColumnSearchOption, geti18nText, NyDataTable, NySession } from '@nybble/nyreact';

const ApplicationIndex = () => {
    const setDefaultFilterValue = () => {
        return [{ field: 'app_type', condition: 'equals', value: GetEnum('APPLICATION_TYPE')['ANDROID'] + '' }];
    };

    return (
        <NyDataTable
            headerTitle={geti18nText('application.table.header')}
            url={CONSTANTS_REQ.APPLICATION.LIST}
            showRecordModal={true}
            exportCSV={true}
            scroll={{ x: 800 }}
            addNewButtonText={geti18nText('application.edit.new')}
            modalComponent={ApplicationEdit}
            setDefaultFilterValue={setDefaultFilterValue}
            columns={[
                {
                    title: geti18nText('application.table.column.id'),
                    dataIndex: 'id',
                    width: '10%',
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('number'),
                },
                {
                    title: geti18nText('application.table.column.name'),
                    dataIndex: 'name',
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('application.table.column.refid'),
                    dataIndex: 'refId',
                    ...getColumnSearch('string'),
                },
                ...(NySession.hasAnyRole(['ROLE_ADMIN', 'ROLE_CUSTOMER_ADMIN'])
                    ? [
                          {
                              title: geti18nText('application.table.customer'),
                              dataIndex: ['customer', 'name'],
                              sorter: (a: any, b: any) => {},
                              ...getColumnSearch('string'),
                          },
                      ]
                    : []),
                {
                    title: geti18nText('application.table.column.active'),
                    dataIndex: 'active',
                    width: '10%',
                    render: (text: any, record: { active: any }) => {
                        if (record.active) {
                            return <CheckOutlined style={{ color: 'green' }} />;
                        } else {
                            return <CloseOutlined style={{ color: 'red' }} />;
                        }
                    },
                    ...getColumnSearchOption(ENUMS.ACTIVE(), 'equals_bool', setDefaultFilterValue()[0]['value']),
                },
            ]}
        />
    );
};

export default ApplicationIndex;
